export class SurgicalOrderAlreadyCancelledError extends Error {
  constructor() {
    super('Pedido cirúrgico já cancelado')
    this.name = 'SurgicalOrderAlreadyCancelledError'
  }
}
